export default {"src":"/_next/static/media/postgresql-logo.60eb9277.svg","height":58,"width":56,"blurWidth":0,"blurHeight":0};